function Finance() {
  return (
    <div>
      <h1>Finance</h1>
      <p>Welcome to Club OS Finance</p>
    </div>
  );
}

export default Finance;